module.exports = __webpack_public_path__ + "media/images/flags/bs-997103bcdae55d136e93d9f4e9a064f9.svg";